import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { DateFilterTypeEnum, IChartData, IDashboard } from "../types";
import { initialState } from "./initialState";

export const useClinicSlice = createSlice({
  name: "dashboardState",
  initialState,
  reducers: {
    setEndDate: (state, action: PayloadAction<Date | string>) => {
      state.endDate = action.payload;
    },
    setFilterValue: (state, action: PayloadAction<DateFilterTypeEnum>) => {
      state.filterValue = action.payload;
    },
    setStartDate: (state, action: PayloadAction<Date | string>) => {
      state.startDate = action.payload;
    },
    setChartData: (state, action: PayloadAction<IChartData>) => {
      state.chartData = action.payload;
    },
    setDashboardsList: (state, action: PayloadAction<IDashboard>) => {
      state.DashboardFormData = action.payload;
    },
    doGetDashboardList: (state) => {},
    getDashboardChartData: (state) => {},
  },
});

export const { reducer, actions, name: sliceKey } = useClinicSlice;
